<template>
  <div class="article-page">
    <main-navbar type="8"></main-navbar>
    <div class="container">
      <div>
        <main-menu></main-menu>
      </div>
      <!-- AD banner -->
      <div v-if="articleDetail.data.userID===27149 || this.articleDetail.data.wxc_hot_haiwai_post"
           class="text-center ad_margin" data-aaad='true' data-aa-adunit='/339474670/Haiwai/ATF'></div>
      <!-- / AD banner -->
      <div class="row">
        <div v-if="!articleDetail.status" class="mt-4 pt-4 mx-auto text-center  mb-4 ">
          <h4>{{ articleDetail.error }}</h4></div>
        <div class="col-sm-8 col-12 ad_paddingr bg-group" v-if="articleDetail.status">
          <div class="bg-content mt-0">
            <previous-next-bar
                class="w-100"
                v-if="articleDetail.data.article_previous_next.next ||articleDetail.data.article_previous_next.previous"
                :data="articleDetail.data">
            </previous-next-bar>
            <h4 class="pb-3 pt-2 mt-0">{{ articleDetail.data.postInfo_postID.title|textTrans }}<span
                v-if="articleDetail.data.is_publish===0"
                class="text-muted">（{{ $t('message').article.hide_text }}）</span></h4>
            <div class="d-flex justify-content-between align-items-center" style="margin-left:-15px">
              <span class="blogger-box">
                <bloger-list-item :data="articleDetail.data" type="small"
                                  @opendialog="$refs.dialog.isLogin()"
                ></bloger-list-item>
              </span>
              <div class="media-icons">
                <span v-if="!$store.state.user.check_is_wxcblog_domain()">
                <span class="buzz_list" v-if="buzz_list.length>0" @click="buzzListTrigger=true">
                  <el-avatar :size="30" :src="item.userinfo_userID.avatar" v-for="item in buzz_list.slice(0,5)"
                             :key="item.userID"
                             style="margin-left:-10px;margin-bottom:-10px">{{ item.userinfo_userID.first_letter }}
                  </el-avatar> {{ buzz_list.length }}
                </span>
                  <button type="button" class="btn btn-icon btn-round btn-neutral"
                          :title="$t('message').article.like_text" @click="like()">
                    <span v-if="articleDetail.data.postInfo_postID.is_buzz" style="fill:#39B8EB"
                          v-html="icons.like"></span>
                    <span v-if="!articleDetail.data.postInfo_postID.is_buzz" style=" stroke:#39B8EB"
                          v-html="icons.like_outline"></span>
                  </button>
                  <button type="button" class="btn btn-icon btn-round btn-neutral"
                          :title="$t('message').article.bookmark_text" style="fill:#39B8EB" @click="bookmark()">
                    <span v-if="articleDetail.data.postInfo_postID.is_bookmark" v-html="icons.star"></span>
                    <span v-if="!articleDetail.data.postInfo_postID.is_bookmark" v-html="icons.star_outline"></span>
                  </button>
                </span>
                <el-popover
                    placement="top-end"
                    trigger="click"
                    v-model="share.showShareBar">
                  <el-popover style="display:inline-block"
                              placement="bottom-end"
                              width="400"
                              trigger="click"
                              visible-arrow="false"
                              v-model="share.wechatQR">
                    <div class="float-right" @click="share.wechatQR=false">
                      {{ $t('message').article.share_wechat_close }}
                    </div>
                    <div class="mt-5">{{ $t('message').article.share_wechat_text }}</div>
                    <img style="margin: 0 95px;" :src="shareItem.QRcode" alt="">
                    <a href="#" @click="share.showShareBar=false" slot="reference"><span class="shareIcon"
                                                                                         v-html="icons.wechat"></span></a>
                  </el-popover>
                  <div class="shareIcons" style="display:inline">
                    <ShareNetwork
                        v-for="item in shareNetworks"
                        :key="item.network"
                        :network="item.network"
                        :url="shareItem.url"
                        :title="shareItem.title"
                        :description="shareItem.description"
                        quote=""
                        hashtags=""
                    >
                      <span class="shareIcon mr-1" v-html="item.icon" @click="share.showShareBar=false"></span>
                    </ShareNetwork>

                    <!-- copy -->

                    <a class="btn bg-white btn-info  p-1 ml-0 mr-0 mb-1" href="#" role="button" @click="copyUrl()">
                      <span v-html="icons.copy"></span>
                    </a>
                    <!-- copy -->
                  </div>

                  <button type="button" class="btn btn-icon btn-round btn-neutral"
                          :title="$t('message').article.share_text" slot="reference">
                    <span style=" fill:#39B8EB;" v-html="icons.share"></span>
                  </button>
                </el-popover>

              </div>
            </div>
            <div class="d-flex align-items-center">
              <div style="color:gray;">{{ articleDetail.data.create_date * 1000 | formatDate }}</div>
              <div style="color:gray;" class="ml-3">{{ $t('message').article.read_count }}:
                {{ articleDetail.data.countinfo_postID.count_read }}
              </div>
              <el-button class="ml-3" type="text" icon="el-icon-edit"
                         v-if="articleDetail.data.userID==$store.state.user.userinfo.UserID||articleDetail.data.bloggerID==$store.state.user.userinfo.bloggerID"
                         style="color:#39b8eb" @click="gotoEditor(articleDetail.data)">{{ $t('message').article.edit }}
              </el-button>

              <el-popconfirm
                  v-if="articleDetail.data.userID==$store.state.user.userinfo.UserID||articleDetail.data.bloggerID==$store.state.user.userinfo.bloggerID"
                  placement="top-end"
                  :confirm-button-text="$t('message').article.comment_delet"
                  :cancel-button-text="$t('message').article.comment_cancel"
                  :title="$t('message').article.delete_confirm"
                  :hide-icon="true"
                  @confirm="article_delete(articleDetail.data)">
                <el-button type="text" icon="el-icon-delete" slot="reference" class="ml-3" style="color:#39b8eb">删除
                </el-button>
              </el-popconfirm>

              <el-popconfirm v-if="$store.state.user.userinfo.UserLevel==2&&articleDetail.data.visible"
                             placement="top-end"
                             :confirm-button-text="$t('message').article.comment_delet"
                             :cancel-button-text="$t('message').article.comment_cancel"
                             :title="$t('message').article.delete_confirm"
                             :hide-icon="true"
                             @confirm="admin_delete(articleDetail.data,0)">
                <el-button type="warning" plain icon="el-icon-delete" slot="reference" class="ml-3">管理員删文章</el-button>
              </el-popconfirm>

              <el-button v-if="!articleDetail.data.visible&&$store.state.user.userinfo.UserLevel==2" type="text"
                         icon="el-icon-refresh-left" slot="reference" class="ml-3" style="color:#39b8eb"
                         @click="admin_delete(articleDetail.data,1)">管理員恢復文章
              </el-button>

              <el-popconfirm v-if="$store.state.user.userinfo.UserLevel==2&&articleDetail.data.visible"
                             placement="top-end"
                             :confirm-button-text="$t('message').article.comment_delet"
                             :cancel-button-text="$t('message').article.comment_cancel"
                             :title="'确定删除此用户吗？'"
                             :hide-icon="true"
                             @confirm="admin_delete_user(articleDetail.data.userinfo_userID.id,0)"
              >
                <el-button type="warning" plain icon="el-icon-delete" slot="reference" class="ml-3">管理員删用户</el-button>
              </el-popconfirm>

              <el-popconfirm v-if="$store.state.user.userinfo.UserLevel==2&&!articleDetail.data.is_wxc_hot"
                             placement="top-end"
                             :confirm-button-text="'确定'"
                             :cancel-button-text="$t('message').article.comment_cancel"
                             :title="'确定将此文章推广到文学城首页吗？'"
                             :hide-icon="true"
                             @confirm="admin_add2wxc(articleDetail.data.postID)"
              >
                <el-button type="success" plain slot="reference" class="ml-3">推wxc首页</el-button>
              </el-popconfirm>

              <el-popconfirm v-if="$store.state.user.userinfo.UserLevel==2&&articleDetail.data.is_wxc_hot"
                             placement="top-end"
                             :confirm-button-text="'确定'"
                             :cancel-button-text="$t('message').article.comment_cancel"
                             :title="'确定将此文章从文学城首页撤下吗？'"
                             :hide-icon="true"
                             @confirm="admin_delete_wxc(articleDetail.data.postID)"
              >
                <el-button type="warning" plain slot="reference" class="ml-3">撤销wxc首页</el-button>
              </el-popconfirm>
            </div>
            <div class="wcontent mb-3">
              <div class="content" id="articleContent"
                   v-html="$options.filters.textTrans(articleDetail.data.postInfo_postID.msgbody)">
                <!-- blog 正文 -->
              </div>
            </div>
            <!-- <script v-if="hasTw" async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> -->
            <previous-next-bar
                v-if="articleDetail.data.article_previous_next.next ||articleDetail.data.article_previous_next.previous"
                :data="articleDetail.data">
            </previous-next-bar>
          </div>
          <div class="comment bg-white px-4 pt-2 my-2" v-if="articleDetail.data.is_comment">
            <textarea type="textarea" v-model="replymsgbody" rows="3" class="w-100 mt-2 p-2"
                      :placeholder="$t('message').article.comment_placeholder" @keyup="checkstatus"></textarea>
            <n-button
                type="primary"
                round
                simple
                :disabled="replybtndisable"
                @click="reply_add">{{ $t('message').article.comment_button }}
            </n-button>
          </div>
          <div v-if="!showcomment" class="text-center">评论数据获取失败</div>
          <div class="bg-white" v-infinite-scroll="getComment"
               infinite-scroll-disabled="disabled"
               infinite-scroll-distance="50" v-if="comment.length>0">
            <h5 class="commentlable px-3">
              {{ $t('message').article.comment_text }}（{{ articleDetail.data.countinfo_postID.count_comment }}）</h5>
            <comment
                v-for="item in comment"
                :key="item.postID"
                :data="item"
                :author="articleDetail.data.userID"
                @regetcomment="rewrite"
                @opendialog="$refs.dialog.isLogin()"
            ></comment>
          </div>
          <div class="text-center py-5" v-if="loading.comment"><!-- loader -->
            <i class="now-ui-icons loader_refresh spin"></i>
          </div>
          <p class="text-center py-4" style="cursor:pointer" v-if="!noMore" @click="getComment">
            {{ $t('message').article.comment_more }}</p>
          <p class="text-center py-4" v-if="noMore">没有更多评论了</p>
          <!-- AD footer -->
          <div v-if="articleDetail.data.userID===27149 || this.articleDetail.data.wxc_hot_haiwai_post" class="OUTBRAIN"
               data-ob-contentUrl="DROP_PERMALINK_HERE"
               data-widget-id="AR_9"
               data-ob-installation-key="ADNIMKAJDGAG4GAO6AGG6H5KP"
          ></div>
          <div id="outbrainWidget"></div>
          <!-- / AD -->

        </div>

        <div class="col-sm-3 px-0 d-none d-sm-block" v-if="articleDetail.status">
          <right-footer></right-footer>
          <!-- r1 -->
          <div class="box ">
              <span class="blogger-box">
                <bloger-list-item :data="articleDetail.data" type="small"
                                  @opendialog="$refs.dialog.isLogin()"></bloger-list-item>
              </span>
            <!-- AD side1 -->
            <div v-if="articleDetail.data.userID===27149 || this.articleDetail.data.wxc_hot_haiwai_post"
                 class="ad_marginy" data-aaad='true' data-aa-adunit='/339474670/Haiwai/Side1'></div>
            <!-- /AD side -->
            <!-- 左边相同样式 -->
            <span v-for="(item,index) in recommend.authorArticle" :key="index">
                 <recommend-list-item :data="item" v-if="index<5"></recommend-list-item>
               </span>
            <div class="justify-content-right border-top d-flex text-right ">
              <router-link :to="'/blog/user/'+articleDetail.data.userID">
                <button type="button" class="btn btn-link btn-default f-right" style="padding-right: 0px;">
                  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                       xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>more</title>
                    <g id="more" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <path d="M11.5740443,6.24199451 L11.5740443,20.2419945 M5,12 L11.5,6 L18,12" id="Arrow"
                            stroke="#6D7278" stroke-width="2"
                            transform="translate(11.500000, 13.120997) rotate(46.000000) translate(-11.500000, -13.120997) "></path>
                      <rect id="Rectangle" stroke="#6D7278" stroke-width="2" x="3" y="3" width="18" height="18"
                            rx="1"></rect>
                    </g>
                  </svg>
                  更多
                </button>
              </router-link>
            </div>
          </div>
          <!-- r3 -->
          <div class="box my-3" v-if="recommend.articles.length>0">
            <div class="title  d-flex justify-content-between">
              <h5>{{ $t('message').article.recomment_text }}</h5>
              <!-- <button type="button" class="btn btn-link btn-default" style="padding-right: 0px;" @click="getRecommend()"><i class="now-ui-icons arrows-1_refresh-69"></i> 换一批</button> -->
            </div>
            <span v-for="(item,index) in recommend.articles" :key="index">
                 <recommend-list-item :data="item" v-if="index<10"></recommend-list-item>
               </span>
          </div>
          <!-- r3 end-->
          <!-- AD side2 -->
          <div v-if="articleDetail.data.userID===27149 || this.articleDetail.data.wxc_hot_haiwai_post"
               class="ad_marginy" data-aaad='true' data-aa-adunit='/339474670/Haiwai/Side2'></div>
          <!-- /AD side -->
          <blog-help></blog-help>
          <!-- AD side -->
          <!-- /AD side -->
        </div>
      </div>
    </div>
    <!-- sticky footer AD -->
    <div class="fixed-bottom bg-white ad_paddingt text-center"
         v-if="articleDetail.data.userID===27149 || this.articleDetail.data.wxc_hot_haiwai_post"
         style="box-shadow:0 -5px 8px #eeeeee">
      <div data-aaad='true' data-aa-adunit='/339474670/Haiwai/StickyFooter'></div>
    </div>
    <!-- /sticky footer AD -->
    <!-- CookiePro CCPA Opt-Out Link Start -->
    <!--    <a href="javascript:void(0)" data-ot-ccpa-opt-out="link" style="display:none;">Do Not Sell My Personal Information</a>-->
    <!-- CookiePro CCPA Opt-Out Link End -->
    <login-dialog ref="dialog"></login-dialog>
    <el-dialog
        :title="'共'+buzz_list.length+'人点赞'"
        :visible.sync="buzzListTrigger"
        width="370px"
        center>
      <div style="max-height:400px;overflow-y:auto">
        <bloger-list-item v-for="item in buzz_list" :data="item" :key="item.userID" type="small"
                          @opendialog="$refs.dialog.isLogin()"></bloger-list-item>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// adcode 引入广告相关代码；
import adcode from '@/module/adCode/adcode';
import MainNavbar from '@/layout/MainNavbar.vue';
import RightFooter from '../../../../layout/RightFooter.vue'
import {formatDate} from '@/directives/formatDate.js';
import {textTrans} from '@/directives/textTrans.js';
import MainMenu from '../components/Main/MainMenu';
import BlogerListItem from '../components/Main/BlogerListItem';
import RecommendListItem from '../components/Main/RecommendListItem';
import {Button} from '@/components';
import icons from "@/components/Icons/Icons";
import Comment from './Comment';
import PreviousNextBar from './PreviousNextBar';
import blog from '../../blog.service';
import {Popover} from 'element-ui';
import LoginDialog from '../../../user/login/LoginDialog.vue';
import BlogHelp from '../components/Main/BlogHelp.vue';

export default {
  name: 'article-page',
  components: {
    MainNavbar,
    MainMenu,
    RightFooter,
    BlogerListItem,
    RecommendListItem,
    Comment,
    PreviousNextBar,
    [Button.name]: Button,
    [Popover.name]: Popover,
    LoginDialog,
    BlogHelp
  },
  mounted: function () {
    this.article_view();
    this.user_login_wxc_to_haiwai(this.token);
    this.getLikes();
  },
  computed: {
    disabled() {
      return this.loading.comment || this.noMore
    }
  },
  methods: {
    insertAD() {
      var odiv = document.getElementById("articleContent");
      var op = odiv.getElementsByTagName('p');
      var ad1 = document.createElement('div');
      var ad2 = document.createElement('div');
      var ad3 = document.createElement('div');
      var ad4 = document.createElement('div');
      ad1.innerHTML = "<div data-aaad='true' class='ad_marginy' data-aa-adunit='/339474670/Haiwai/Middle1'></div>";
      ad2.innerHTML = "<div data-aaad='true' class='ad_marginy' data-aa-adunit='/339474670/Haiwai/Middle2'></div>";
      ad3.innerHTML = "<div data-aaad='true' class='ad_marginy' data-aa-adunit='/339474670/Haiwai/Middle3'></div>";
      ad4.innerHTML = "<div data-aaad='true' class='ad_marginy' data-aa-adunit='/339474670/Haiwai/Middle4'></div>";
      for (let i = 0; i < op.length; i++) {
        if (i === 5) odiv.insertBefore(ad1, op[i]);
        if (i === 10) odiv.insertBefore(ad2, op[i]);
        if (i === 15) odiv.insertBefore(ad3, op[i]);
        if (i === 20) odiv.insertBefore(ad4, op[i]);
      }
    },
    setTitle() {
      document.title = this.shareItem.title
    },
    article_view() {
      this.showcomment = false;
      let postid = this.$route.params.id;
      blog.article_view(postid).then(res => {
        this.articleDetail = res;
        // baseCode() 加载广告环境基础代码 27149:生活指南文章才加广告
        if (this.articleDetail.data.userID === 27149 || this.articleDetail.data.wxc_hot_haiwai_post) {
          adcode.baseCode();
        }
        if (res.status) {
          let descrip = res.data.postInfo_postID.msgbody
          this.shareItem.title = res.data.postInfo_postID.title;
          this.shareItem.description = descrip.replace(/<[^>]+>/g, "").substr(0, 100);
          this.initRecommendProp(res);
          this.getRecentArticle(res, 0);
          this.getComment();
          this.hasTw();
          this.setTitle();
          this.check_iswxc_hot(res.data.postID);
        }
        setTimeout(() => {
          this.insertAD();
        }, 50)
      });
    },
    getLikes() {
      let postid = this.$route.params.id;
      blog.article_buzz_list(postid).then(res => {
        this.buzz_list = res.status ? res.data : ''
      })
    },
    initRecommendProp(res) {
      var arr = [];
      res.data.postInfo_postID.tags.forEach(r => {
        arr.push(r.id)
      });
      this.recommend.props.tags = arr.length > 0 ? arr.toString() : ''
      this.recommend.props.lastID = 0;
      this.getRecommend()
    },
    getRecommend() {
      let postID = this.$route.params.id;
      blog.article_list_tag(this.recommend.props.tags, postID, this.recommend.props.lastID).then(res => {
        if (res.status) {
          let arr = res.data
          this.recommend.articles = arr;
          this.recommend.props.lastID = arr.length > 10 ? arr[arr.length - 1].create_date : 0;
        }
      })
    },
    getRecentArticle(res, lastID) {
      let postID = this.$route.params.id;
      var bloggerID = res.data.bloggerID;
      blog.article_list_recent(bloggerID, lastID, postID).then(res => {
        if (res.status) {
          this.recommend.authorArticle = res.data
        }
        this.loadAd();
      })
    },
    loadAd() {
      /**
       *  init_ad() 页面内容加载后调用，注意：放在mounted中不起作用；
       * 页面内容中的广告资源格式例如：data-aa-adunit='/339474670/Haiwai/Side1';
       * outbrainWidgets() 2*3 广告widgets
       */
      if (this.articleDetail.data.userID === 27149 || this.articleDetail.data.wxc_hot_haiwai_post) {
        adcode.initAd();
        adcode.outbrainWidgets();
      }

    },
    reply_add() {
      if (!this.check_user_login()) return;
      let obj = {
        article_data: {
          msgbody: this.wrapToBr(this.replymsgbody),
          postID: this.articleDetail.data.postID,
          typeID: 1
        }
      }
      this.replybtndisable = true;
      blog.reply_add(obj).then(res => {
        this.replybtndisable = false;
        if (res.status) {
          this.getFirst20();
        } else {
          this.$message.error(res.error)
        }

        this.replymsgbody = "";
      })
    },
    checkstatus() {
      this.replybtndisable = this.replymsgbody ? false : true;
    },
    getFirst20() {
      this.lastID = 0;
      this.comment = [];
      this.getComment();
    },
    getComment() {
      this.loading.comment = true;
      this.noMore = false;
      if (this.$store.state.user.userinfo.UserLevel != 2) {
        blog.article_view_comment(this.$route.params.id, this.lastID).then(res => {
          let r = res.data;
          this.comment = this.comment.concat(r);
          this.lastID = r.length > 0 ? r[r.length - 1].postID : 0;
          if (r.length < 20) {
            this.noMore = true;
          }
          this.showcomment = res.status ? true : false;
          this.loading.comment = false;
        })
      } else {
        this.$store.state.user.article_view_comment(this.$route.params.id, this.lastID).then(res => {
          let r = res.data;
          this.comment = this.comment.concat(r);
          this.lastID = r.length > 0 ? r[r.length - 1].postID : 0;
          if (r.length < 20) {
            this.noMore = true;
          }
          this.showcomment = res.status ? true : false;
          this.loading.comment = false;
        })
      }
    },
    rewrite(id) {
      if (!this.check_user_login()) return;
      if (!id) {
        this.comment.splice(0, 1)
      }
      blog.article_view_comment_one(id).then(res => {
        this.comment.forEach(obj => {
          if (obj.postID == id) {
            let idx = this.comment.indexOf(obj);
            this.comment.splice(idx, 1, res.data)
          }
        })
      })
    },
    // 喜欢
    like() {
      if (!this.check_user_login()) return;
      if (this.articleDetail.data.postInfo_postID.is_buzz == 0) {
        this.buzz_add(this.articleDetail.data);
      } else {
        this.buzz_delete(this.articleDetail.data);
      }
    },
    buzz_add(item) {
      blog.buzz_add(item.postID).then(res => {
        if (res.status) {
          this.articleDetail.data.postInfo_postID.is_buzz = 1
        }
      })
    },
    buzz_delete(item) {
      blog.buzz_delete(item.postID).then(res => {
        if (res.status) {
          this.articleDetail.data.postInfo_postID.is_buzz = 0
        }
      })
    },
    // 收藏
    bookmark() {
      if (!this.check_user_login()) return;
      this.articleDetail.data.postInfo_postID.is_bookmark ? this.bookmark_delete(this.articleDetail.data) : this.bookmark_add(this.articleDetail.data)
    },
    bookmark_add(item) {
      blog.bookmark_add(item.postID).then(res => {
        if (res.status) this.articleDetail.data.postInfo_postID.is_bookmark = 1;
      })
    },
    bookmark_delete(item) {
      blog.bookmark_delete(item.postID).then(res => {
        if (res.status) this.articleDetail.data.postInfo_postID.is_bookmark = 0;
      })
    },
    gotoEditor(item) {
      let url = '/blog/my/editor/?postid=' + item.postID;
      if (this.articleDetail.data.bloggerID !== this.$store.state.user.userinfo.bloggerID) {
        this.$store.state.user.getGroupBlogs().then(res => {
          if (res.status) {
            var groupBloger = res.data.filter(x => {
              return x.bloggerID === this.articleDetail.data.bloggerID
            })
            this.$store.commit('setGroupBlogEditer', groupBloger[0]);
            this.$router.push(url);
          }
        })
      } else {
        this.$store.commit('setGroupBlogEditer', this.$store.state.user.userinfo);
        this.$router.push(url);
      }
    },
    article_delete(item) {
      blog.article_delete(item.postID, 0).then(res => {
        if (res.status) {
          this.$router.push('/blog/')
        }
      })
    },
    admin_delete(item, type) {
      this.$store.state.user.admin_article_delete(item.postID, type).then(res => {
        if (res.status) {
          item.visible = type;
        }
      })
    },
    admin_delete_user(userID, status) {
      this.$store.state.user.user_delete(userID, status).then(res => {
        if (res.status) {
          this.$message.success('该用户已被封禁！')
        }
      })
    },
    admin_add2wxc(postID) {
      this.$store.state.user.wxc_hot_blog_add(postID).then(res => {
        this.check_iswxc_hot(postID);
        this.$message.success('该文章推荐成功！');
      })
          .catch(err => {
            this.$message.error('操作失败！')
          })
    },
    admin_delete_wxc(postID) {
      this.$store.state.user.wxc_hot_blog_delete(postID).then(res => {
        this.check_iswxc_hot(postID);
        this.$message.success('已从文学城首页撤下！');
      })
          .catch(err => {
            this.$message.error('操作失败！')
          })
    },
    check_iswxc_hot(postID) {
      this.$store.state.user.wxc_hot_blog_check(postID).then(res => {
        this.articleDetail.data.is_wxc_hot = res.data;
        this.$forceUpdate();
      })
          .catch(err => {
            console.log(err)
          })
    },
    user_login_wxc_to_haiwai(token) {
      let user = this.$store.state.user;
      if (this.token && !user.userinfo.id) {
        user.user_login_wxc_to_haiwai(token).then(res => {
          user.getUserInfo(this.$route.params.id).then(res => {
            this.$router.push('/blog/p/' + this.$route.params.id)
          })
        })
      } else {
        this.$router.push('/blog/p/' + this.$route.params.id)
      }
    },
    wrapToBr(text) {
      var string = text;
      try {
        string = string.replace(/\r\n/g, "<br>")
        string = string.replace(/\n/g, "<br>");
        string = string.replace(/\r/g, "<br>");
        string = string.replace(/\s/g, "&nbsp;");
      } catch (e) {
        console.log(e.message);
      }
      return string;
    },
    hasTw() {
      var content = this.articleDetail.data.postInfo_postID.msgbody
      if (content) {
        if (content.indexOf("twitter-tweet") !== -1) {
          this.addTw();
        }
      }
    },
    addTw() {
      let script = document.getElementById('hasTw');
      if (!script) {
        script = document.createElement('script');
        script.id = 'hasTw';
        script.src = 'https://platform.twitter.com/widgets.js';
        script.charset = 'utf-8';
        document.body.append(script);
      }
    },
    copyUrl() {
      var oInput = document.createElement("input"); //创建隐形input
      oInput.value = window.location.href; // window.location.href 浏览器URL
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message.success("本文链接已复制成功！");
      this.share.showShareBar = false;
    },
  },
  data() {
    return {
      // showLogin:false,
      icons: icons,
      loginuserID: -1,
      showcomment: false,
      articleDetail: {},
      comment: [],
      replymsgbody: "",
      replybtndisable: true,
      lastID: 0,
      noMore: false,
      loading: {comment: false},
      share: {
        showShareBar: false,
        wechatQR: false
      },
      shareItem: {
        url: window.location.href,
        title: '',
        description: '',
        QRcode: 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' + window.location.href
      },
      shareNetworks: [
        {
          network: 'line',
          icon: icons.line
        },
        {
          network: 'facebook',
          icon: icons.facebook
        }, {
          network: 'twitter',
          icon: icons.twitter
        },
        {
          network: 'weibo',
          icon: icons.weibo
        },
        {
          network: 'whatsapp',
          icon: icons.whatsapp
        }

      ],
      recommend: {
        authorArticle: [],
        articles: [],
        props: {
          lastID: 0,
          tags: ''
        }
      },
      token: this.$route.query.token,
      buzz_list: [],
      buzzListTrigger: false
    };
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    },
    textTrans(string) {
      return textTrans(string);
    }
  }
};
</script>
<style>

.fontsize0 .content {
  font-size: 0.9rem;
}

.fontsize1 .content {
  font-size: 1.3rem;
}

.fontsize2 .content {
  font-size: 1.5rem;
}

.article-page .box {
  background-color: #f6f9fc;
  border-radius: 16px;
  padding: 10px 0
}

.article-page .title {
  padding: 0 18px;
}

.article-page p {
  font-size: inherit
}

.article-page h5 {
  margin-top: 15px;
  font-weight: 400
}

.article-page .commentlable {
  border-bottom: #ddd 1px solid;
  padding: 10px 0;
  margin-bottom: 12px;
}

.article-page .comment textarea {
  border: #ddd 1px solid;
}

.comment .replyContent {
  /*width:680px;*/
  width: auto;
  word-break: break-all;
}

/* r2 */
.shareIcons a:hover {
  text-decoration: none;
}

.shareIcon svg {
  width: 28px;
  height: 28px;
}

.article-page h4 {
  margin-bottom: 0;
  font-size: 24px
}

.article-page .content {
  padding-top: 1rem;
  word-break: break-all;
}

.article-page .content p img,
.article-page .content p iframe {
  width: 85%;
  margin: 0 auto;
  display: block;
}

.article-page .blogger-box {
  width: 300px
}

.article-page .media-icons .btn {
  font-size: 1.5rem !important;
  margin: -5px 0 0 0;
}

.buzz_list {
  font-size: 13px;
  cursor: pointer;
}

.article-page .wcontent {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 1.8em;
  overflow: hidden
}

@media (max-width: 575.98px) {
  .article-page .blogger-box {
    width: 220px
  }

  .article-page .content p img,
  .article-page .content p iframe {
    width: 100%;
  }

  .comment .replyContent {
    width: 370px
  }
}
</style>
